import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation CreateParticipantGroups($formId: Int!, $participantGroups: [NewParticipantGroupInput]!) {
    createParticipantGroups(input: { form_id: $formId, participant_groups: $participantGroups }) {
      participant_groups {
        id
        name
        form_id
        description
        participant_fee
      }
    }
  }
`;
